import moment from 'moment-timezone'

const DEFAULT_DATE_FORMAT = 'ddd, DD MMM YY'

/**
 * Calculate a purchased gift cards expiry date using an expiry period, expiry period type and the retailers time zone.
 *
 * @param  expiryPeriod
 *
 * @param  expiryPeriodType
 *
 * @param  [timeZone]
 *         The time zone to display the date/time in
 *
 * @return The formatted date
 */
export function calculateGiftCardExpiry(
  expiryPeriod: number,
  expiryPeriodType: 'YEARS' | 'MONTHS' | 'DAYS',
  timeZone?: string
): string {
  const currentUTCTime = moment().utc()
  let expiryDate

  switch (expiryPeriodType) {
    case 'YEARS':
      expiryDate = moment(currentUTCTime).add(expiryPeriod, 'y')
      break
    case 'MONTHS':
      expiryDate = moment(currentUTCTime).add(expiryPeriod, 'M')
      break
    case 'DAYS':
      expiryDate = moment(currentUTCTime).add(expiryPeriod, 'd')
      break
  }

  if (!expiryDate) {
    return ''
  }

  if (timeZone) {
    expiryDate.tz(timeZone)
  }

  return expiryDate.format(DEFAULT_DATE_FORMAT)
}
